import { BeforeAfterData, BeforeAfterDataSource } from '../../types/types';
import { getUserLang } from '../langUtils';
import ReviewModal from './ReviewModal';

export default class BeforeAfter {
  caseId: number = 0;

  buttons!: HTMLElement[];

  beforeImg!: HTMLImageElement;

  afterImg!: HTMLImageElement;

  caseNumberText!: HTMLElement;

  beforeText!: HTMLElement;

  afterText!: HTMLElement;

  reviewModal!: ReviewModal;

  spinnerElement!: HTMLElement;

  casesData!: BeforeAfterData;

  constructor() {
    const lang = getUserLang();
    this.loadBeforeAfterData(lang).then((data) => {
      this.casesData = data;
      this.init();
      this.bindEvents();
    });
  }

  init = () => {
    this.buttons = Array.from(document.querySelectorAll('.before-after__img-titles [data-ba-case]')) as HTMLElement[];
    const baSliderElement = document.querySelector('.before-after__slider') as HTMLElement;
    this.beforeImg = baSliderElement.firstElementChild?.firstElementChild as HTMLImageElement;
    this.afterImg = baSliderElement.lastElementChild?.previousElementSibling?.firstElementChild as HTMLImageElement;
    this.spinnerElement = baSliderElement.lastElementChild as HTMLElement;
    const baDescElement = document.querySelector('.before-after__desc') as HTMLElement;
    this.caseNumberText = baDescElement.firstElementChild?.firstElementChild?.firstElementChild as HTMLElement;
    this.beforeText = baDescElement.firstElementChild?.firstElementChild?.lastElementChild as HTMLElement;
    this.afterText = baDescElement.firstElementChild?.lastElementChild?.lastElementChild as HTMLElement;
    this.reviewModal = new ReviewModal('.before-after__review-btn', '.before-after', this.casesData);
  };

  bindEvents = () => {
    this.checkInitialImagesLoaded();
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target as HTMLElement;
        this.changeCase(Number(target.dataset.baCase));
      });
    });
  };

  removeSpinner = () => {
    this.spinnerElement?.classList.remove('loading');
  };

  checkInitialImagesLoaded = () => {
    // Сразу проверяем - возможно изображения уже загружены
    this.checkBothImagesLoaded();

    // Если не загружены, ждем событие load
    if (!this.beforeImg.complete) {
      this.beforeImg.addEventListener('load', this.checkBothImagesLoaded, { once: true });
    }
    if (!this.afterImg.complete) {
      this.afterImg.addEventListener('load', this.checkBothImagesLoaded, { once: true });
    }
  };

  checkBothImagesLoaded = () => {
    if (this.beforeImg.complete && this.afterImg.complete) {
      this.removeSpinner();
    }
  };

  addSpinner = () => {
    this.spinnerElement?.classList.add('loading');
    this.beforeImg.addEventListener('load', () => {
      if (this.afterImg.complete) this.removeSpinner();
    });
    this.afterImg.addEventListener('load', () => {
      if (this.beforeImg.complete) this.removeSpinner();
    });
  };

  changeCase = (caseId: number) => {
    this.addSpinner();
    this.buttons[this.caseId].classList.remove('active');
    this.buttons[caseId].classList.add('active');
    this.caseId = caseId;
    this.beforeImg.srcset = this.casesData.cases[caseId].beforeImg + '.jpg 2x';
    this.beforeImg.src = this.casesData.cases[caseId].beforeImg + '-s.jpg';
    this.beforeImg.alt = `${this.casesData.caseName} ${caseId + 1} ${this.casesData.before1}`;
    this.afterImg.srcset = this.casesData.cases[caseId].afterImg + '.jpg 2x';
    this.afterImg.src = this.casesData.cases[caseId].afterImg + '-s.jpg';
    this.afterImg.alt = `${this.casesData.caseName} ${caseId + 1} ${this.casesData.after1}`;
    this.caseNumberText.innerText = this.casesData.caseName + ' ' + (caseId + 1);
    this.beforeText.innerText = this.casesData.cases[caseId].before;
    this.afterText.innerText = this.casesData.cases[caseId].after;
    this.reviewModal.changeReview(caseId);
  };

  loadBeforeAfterData = async (lang: string) => {
    const response = await fetch(`/${lang}/beforeAfter.json`);
    const data = await response.json();
    return this.handleBeforeAfterData(data);
  };

  handleBeforeAfterData = (data: BeforeAfterDataSource) => {
    const handledData: BeforeAfterData = {
      ...data,
      cases: [data.case1, data.case2, data.case3, data.case4, data.case5],
    };
    return handledData;
  };
}
